import { translations } from "i18n";
import React, { useCallback } from "react";
import Modal from "react-modal";
import cn from "classnames";

import { useConnectedDevices } from "hooks/ConnectedDevicesHook";

import iconToy from "images/i-toy.png";
import iconBLE from "images/i-bluetooth.png";
import iconBattery from "images/i-charged.png";
import iconPower from "images/i-turned-on.png";

import styles from "./style.module.scss";
import { MODAL_STYLES } from "data/constants";
import Solution from "./Solution";

const ConnectionFailed = () => {
  const { reloadPage, recommendationsVisible, setRecommendationsVisible } =
    useConnectedDevices();
  Modal.setAppElement("#root");

  const skipModal = useCallback(() => {
    setRecommendationsVisible(false);
  }, []);

  const closeModal = () => {
    reloadPage ? window.location.reload() : skipModal();
  };

  return (
    <Modal
      isOpen={recommendationsVisible}
      onRequestClose={closeModal}
      style={MODAL_STYLES}
    >
      <div className={styles.container}>
        <div className={styles.warningRectangle}>
          <p>{translations("ConnectionFailed.UnableToConnect")}</p>
        </div>

        <div className={styles.subHeader}>
          <p>Lets try again. Please make sure that:</p>
        </div>

        <Solution
          title={translations("ConnectionFailed.Compatible")}
          info={translations("ConnectionFailed.CompatibleInfo")}
          icon={iconToy}
        />
        <Solution
          title={translations("ConnectionFailed.Battery")}
          info={translations("ConnectionFailed.BatteryInfo")}
          icon={iconBattery}
        />
        <Solution
          title={translations("ConnectionFailed.Power")}
          info={translations("ConnectionFailed.PowerInfo")}
          icon={iconPower}
        />
        <Solution
          title={translations("ConnectionFailed.Bluetooth")}
          info={translations("ConnectionFailed.BluetoothInfo")}
          icon={iconBLE}
        />

        <div className={styles.buttonsContainer}>
          <div
            onClick={closeModal}
            className={cn(
              styles.button,
              reloadPage ? styles.reload : styles.cancel
            )}
          >
            <p>
              {translations(
                reloadPage ? "MenuContainer.Reload" : "General.Skip"
              )}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConnectionFailed;
